/*
============================================================
VARIKAA AI EXPERIENCE ENGINE
FINAL V2 — METAFIZZ+
============================================================

FLOW:

PRODUCT PAGE
    ↓
18% SCROLL
    ↓
FULL-SCREEN TABLET DROP
    ↓
INVITATION
    ↓
LET'S FIND OUT
    ↓
QUESTION 1
    ↓
QUESTION 2
    ↓
QUESTION 3
    ↓
QUESTION 4
    ↓
PERSONALISED RESULT
    ↓
VISUAL SUMMARY
    ↓
EXPANDABLE DETAILS
    ↓
STICKY CTA

IMPORTANT:

- No separate intro screen
- Clicking "Let's find out" opens Q1 directly
- No Continue button
- Answers auto-advance
- Back button available
- Result is compact
- Result uses graphical summary
- Detailed information uses accordions
- CTA remains sticky
- No checkout URL creation
- No Shiprocket recreation
- No preventDefault
- Existing Shopify / Shiprocket flow remains authoritative

============================================================
*/


(function () {

  "use strict";


  /* ========================================================
     01. INITIALISATION
     ======================================================== */

  function initVarikaaAI() {

    var root =
      document.getElementById(
        "varikaa-ai-experience"
      );


    if (!root) {

      return;

    }


    /*
    ----------------------------------------------------------
    Prevent duplicate initialisation
    ----------------------------------------------------------
    */

    if (
      root.dataset.varikaaAiInitialized === "true"
    ) {

      return;

    }


    root.dataset.varikaaAiInitialized =
      "true";


    /*
    ----------------------------------------------------------
    Current Shopify product
    ----------------------------------------------------------
    */

    var productHandle =
      root.dataset.productHandle || "";


    /*
    ----------------------------------------------------------
    Product configuration
    ----------------------------------------------------------
    */

    var products =
      window.VARIKAA_AI_PRODUCTS || {};


    var product = null;

/*
============================================================
PRODUCT ROUTING
- MetaFizz+ → existing MetaFizz configuration
- Moringa → new Moringa configuration
- Other products → AI experience stays inactive
============================================================
*/

if (
  productHandle.includes("metafizz")
) {
  product = products.metafizz_plus;
}

if (
  productHandle === "natural-moringa-powder"
) {
  product = products.moringa;
}
else if (
  productHandle === "psyllium-husk-powder-100-g"
) {
  product = products.isabgol;
}
if (!product) {
  return;
}


    if (!product) {

      console.warn(
        "[Varikaa AI] MetaFizz+ configuration not found."
      );

      return;

    }


    /* ========================================================
       02. STATE
       ======================================================== */

    var state = {

      currentQuestion: 0,

      answers: {

        q1: "",

        q2: "",

        q3: "",

        q4: ""

      },

      guideOpened: false,

      resultShown: false

    };


    /* ========================================================
       03. ANALYTICS
       ======================================================== */

    function trackEvent(
      eventName,
      parameters
    ) {

      try {

        if (
          typeof window.gtag === "function"
        ) {

          window.gtag(
            "event",
            eventName,
            parameters || {}
          );

        }

      } catch (error) {}


      try {

        window.dataLayer =
          window.dataLayer || [];


        window.dataLayer.push({

          event:
            eventName,

          ...(parameters || {})

        });

      } catch (error) {}

    }


    /* ========================================================
       04. SAFE HTML
       ======================================================== */

    function escapeHtml(
      value
    ) {

      return String(
        value == null
          ? ""
          : value
      )

        .replace(
          /&/g,
          "&amp;"
        )

        .replace(
          /</g,
          "&lt;"
        )

        .replace(
          />/g,
          "&gt;"
        )

        .replace(
          /"/g,
          "&quot;"
        )

        .replace(
          /'/g,
          "&#039;"
        );

    }


    /* ========================================================
       05. BUILD EXPERIENCE
       ======================================================== */

    function buildExperience() {

      /*
      --------------------------------------------------------
      HERO
      --------------------------------------------------------
      */

      var hero =
        document.createElement(
          "div"
        );


      hero.id =
  "varikaa-ai-hero-trigger";

hero.className =
  "varikaa-ai-hero-" + productHandle;

hero.innerHTML =

        '<div id="varikaa-ai-hero-object">' +

          '<img ' +
            'id="varikaa-ai-hero-image" ' +
            'src="' +
              escapeHtml(
                product.hero.heroImage
              ) +
            '" ' +
            'alt="' +
              escapeHtml(
                product.name
              ) +
            '" ' +
            'loading="lazy"' +
          '>' +

          '<img ' +
            'id="varikaa-ai-hero-splash" ' +
            'src="' +
              escapeHtml(
                product.hero.splashImage
              ) +
            '" ' +
            'alt="" ' +
            'aria-hidden="true" ' +
            'loading="lazy"' +
          '>' +

        '</div>';


      document.body.appendChild(
        hero
      );


      /*
      --------------------------------------------------------
      INVITATION
      --------------------------------------------------------
      */

      var invitation =
        document.createElement(
          "div"
        );


      invitation.id =
        "varikaa-ai-hero-invitation";


      invitation.innerHTML =

        '<p ' +
          'id="varikaa-ai-hero-invitation-title"' +
        '>' +

          escapeHtml(
            product.hero.invitationTitle
          ) +

        '</p>' +

        '<span ' +
          'id="varikaa-ai-hero-invitation-action"' +
        '>' +

          escapeHtml(
            product.hero.invitationAction
          ) +

        '</span>';


      document.body.appendChild(
        invitation
      );


      /*
      --------------------------------------------------------
      MODAL
      --------------------------------------------------------
      */

      var overlay =
        document.createElement(
          "div"
        );


      overlay.id =
        "varikaa-ai-overlay";


      overlay.setAttribute(
        "aria-hidden",
        "true"
      );


      overlay.innerHTML =

        '<div ' +
          'id="varikaa-ai-panel" ' +
          'role="dialog" ' +
          'aria-modal="true"' +
        '>' +

          '<button ' +
            'type="button" ' +
            'id="varikaa-ai-close" ' +
            'aria-label="Close routine guide"' +
          '>' +

            '×' +

          '</button>' +

          '<div id="varikaa-ai-progress">' +

            '<div id="varikaa-ai-progress-bar"></div>' +

          '</div>' +

          '<div id="varikaa-ai-content"></div>' +

        '</div>';


      document.body.appendChild(
        overlay
      );


      return {

        hero:
          hero,

        heroObject:
          hero.querySelector(
            "#varikaa-ai-hero-object"
          ),

        invitation:
          invitation,

        overlay:
          overlay,

        panel:
          overlay.querySelector(
            "#varikaa-ai-panel"
          ),

        close:
          overlay.querySelector(
            "#varikaa-ai-close"
          ),

        progressBar:
          overlay.querySelector(
            "#varikaa-ai-progress-bar"
          ),

        content:
          overlay.querySelector(
            "#varikaa-ai-content"
          )

      };

    }


    var ui =
      buildExperience();


    if (!ui) {

      return;

    }


    /* ========================================================
       06. SCROLL TRIGGER
       ======================================================== */

    var heroShown =
      false;


    function getScrollPercentage() {

      var documentElement =
        document.documentElement;


      var scrollTop =
        window.pageYOffset ||
        documentElement.scrollTop ||
        0;


      var documentHeight =
        documentElement.scrollHeight;


      var viewportHeight =
        window.innerHeight;


      var scrollable =
        documentHeight -
        viewportHeight;


      if (
        scrollable <= 0
      ) {

        return 0;

      }


      return (
        scrollTop /
        scrollable
      ) * 100;

    }


    function showHero() {

      if (heroShown) {

        return;

      }


      heroShown =
        true;


      ui.hero.classList.add(
        "is-visible"
      );


      requestAnimationFrame(
        function () {

          ui.hero.classList.add(
            "is-entering"
          );

        }
      );


      setTimeout(
        function () {

          ui.hero.classList.add(
            "is-splashing"
          );

          ui.hero.classList.add(
            "is-stable"
          );

        },
        520
      );


      setTimeout(
        function () {

          ui.invitation.classList.add(
            "is-visible"
          );

        },
        850
      );


      trackEvent(
        "varikaa_ai_hero_shown",
        {

          product:
            product.id,

          scroll_depth:
            product.hero
              .triggerAfterScrollPercent

        }
      );

    }


    function checkScroll() {

      if (heroShown) {

        return;

      }


      var scrollPercent =
        getScrollPercentage();


      if (
        scrollPercent >=
        product.hero
          .triggerAfterScrollPercent
      ) {

        showHero();

      }

    }


    window.addEventListener(
      "scroll",
      checkScroll,
      {
        passive: true
      }
    );


    setTimeout(
      checkScroll,
      500
    );


    /* ========================================================
       07. OPEN GUIDE
       ======================================================== */

    function openGuide() {

      if (!ui.overlay) {

        return;

      }


      state.guideOpened =
        true;


      state.currentQuestion =
        0;


      state.answers = {

        q1: "",

        q2: "",

        q3: "",

        q4: ""

      };


      state.resultShown =
        false;


      ui.overlay.classList.add(
        "is-open"
      );


      ui.overlay.setAttribute(
        "aria-hidden",
        "false"
      );


      document.documentElement.classList.add(
        "varikaa-ai-lock-scroll"
      );


      document.body.classList.add(
        "varikaa-ai-lock-scroll"
      );


      /*
      ========================================================
      IMPORTANT

      DIRECTLY OPEN QUESTION 1.

      There is NO intro screen.
      There is NO second "Let's find out".
      ========================================================
      */

      renderQuestion();


      trackEvent(
        "varikaa_ai_opened",
        {

          product:
            product.id

        }
      );


      trackEvent(
        "varikaa_ai_started",
        {

          product:
            product.id

        }
      );

    }


    /* ========================================================
       08. CLOSE GUIDE
       ======================================================== */

    function closeGuide() {

      ui.overlay.classList.remove(
        "is-open"
      );


      ui.overlay.setAttribute(
        "aria-hidden",
        "true"
      );


      document.documentElement.classList.remove(
        "varikaa-ai-lock-scroll"
      );


      document.body.classList.remove(
        "varikaa-ai-lock-scroll"
      );


      resetState();


      trackEvent(
        "varikaa_ai_closed",
        {

          product:
            product.id

        }
      );

    }


    /* ========================================================
       09. RESET
       ======================================================== */

    function resetState() {

      state.currentQuestion =
        0;


      state.answers = {

        q1: "",

        q2: "",

        q3: "",

        q4: ""

      };


      state.resultShown =
        false;

    }


    /* ========================================================
       10. PROGRESS
       ======================================================== */

    function updateProgress() {

      var total =
        product.questions.length;


      var current =
        state.currentQuestion + 1;


      var percentage =
        (
          current /
          total
        ) * 100;


      ui.progressBar.style.width =
        percentage + "%";

    }


    /* ========================================================
       11. ICON SYSTEM
       ======================================================== */

    function getOptionIcon(
  questionId,
  value,
  option
) {

  /*
  ============================================================
  VARIKAA AI — ICON SYSTEM
  Product-specific option icons take priority.
  Existing MetaFizz icons remain unchanged.
  ============================================================
  */

  if (
    option &&
    option.icon
  ) {

    return option.icon;

  }


  var icons = {

    q1: {

      weight:
        "⚖️",

      cravings:
        "🍎",

      energy:
        "⚡",

      gut:
        "🌿",

      combination:
        "✨"

    },


    q2: {

      busy:
        "🏃",

      desk:
        "💻",

      active:
        "🏋️",

      home:
        "🏠",

      changing:
        "🔄"

    },


    q3: {

      ingredients:
        "🌿",

      benefits:
        "✨",

      taste:
        "🥤",

      convenience:
        "⏱️",

      consistency:
        "🔁"

    },


    q4: {

      simple:
        "✨",

      morning:
        "🌅",

      refreshing:
        "🥤",

      structured:
        "📋",

      figuring_out:
        "🤷"

    }

  };


  if (
    icons[questionId] &&
    icons[questionId][value]
  ) {

    return icons[
      questionId
    ][value];

  }


  return "•";

}

    /* ========================================================
       12. RENDER QUESTION
       ======================================================== */

    function renderQuestion() {

      var questions =
        product.questions;


      var question =
        questions[
          state.currentQuestion
        ];


      if (!question) {

        showResult();

        return;

      }


      updateProgress();


      var selectedValue =
        state.answers[
          question.id
        ] || "";


      var optionsHtml =
        question.options
          .map(
            function (option) {

              var selectedClass =
                selectedValue ===
                option.value
                  ? " is-selected"
                  : "";


              var icon =
                getOptionIcon(
                  question.id,
                  option.value,
                 option 
                );


              return (

                '<button ' +

                  'type="button" ' +

                  'class="varikaa-ai-option' +
                    selectedClass +
                  '" ' +

                  'data-question="' +
                    escapeHtml(
                      question.id
                    ) +
                  '" ' +

                  'data-value="' +
                    escapeHtml(
                      option.value
                    ) +
                  '"' +

                '>' +

                  '<span class="varikaa-ai-option-icon">' +

                    icon +

                  '</span>' +

                  '<span class="varikaa-ai-option-label">' +

                    escapeHtml(
                      option.label
                    ) +

                  '</span>' +

                  '<span class="varikaa-ai-option-check">' +

                    '✓' +

                  '</span>' +

                '</button>'

              );

            }
          )
          .join("");


      var backHtml =
        state.currentQuestion > 0

          ? (

              '<button ' +
                'type="button" ' +
                'id="varikaa-ai-back"' +
              '>' +

                '← Back' +

              '</button>'

            )

          : "";


      ui.content.innerHTML =

        '<div class="varikaa-ai-question">' +

          '<div class="varikaa-ai-question-number">' +

            'Question ' +

            (
              state.currentQuestion + 1
            ) +

            ' of ' +

            questions.length +

          '</div>' +

          '<h2 class="varikaa-ai-question-title">' +

            escapeHtml(
              question.title
            ) +

          '</h2>' +

          '<div class="varikaa-ai-options">' +

            optionsHtml +

          '</div>' +

          backHtml +

        '</div>';


      bindQuestionOptions();

      bindBackButton();

    }


    /* ========================================================
       13. QUESTION OPTIONS
       ======================================================== */

    function bindQuestionOptions() {

      var optionButtons =
        ui.content.querySelectorAll(
          ".varikaa-ai-option"
        );


      optionButtons.forEach(
        function (button) {

          button.addEventListener(
            "click",
            function () {

              var questionId =
                button.dataset.question;


              var value =
                button.dataset.value;


              state.answers[
                questionId
              ] =
                value;


              optionButtons.forEach(
                function (item) {

                  item.classList.remove(
                    "is-selected"
                  );

                }
              );


              button.classList.add(
                "is-selected"
              );


              trackEvent(
                "varikaa_ai_answer_selected",
                {

                  product:
                    product.id,

                  question:
                    questionId,

                  answer:
                    value

                }
              );


              /*
              ------------------------------------------------
              Auto advance.

              No Continue button.
              ------------------------------------------------
              */

              setTimeout(
                function () {

                  if (
                    state.currentQuestion <
                    product.questions.length - 1
                  ) {

                    state.currentQuestion++;

                    renderQuestion();

                  } else {

                    showResult();

                  }

                },
                180
              );

            }
          );

        }
      );

    }


    /* ========================================================
       14. BACK
       ======================================================== */

    function bindBackButton() {

      var back =
        document.getElementById(
          "varikaa-ai-back"
        );


      if (!back) {

        return;

      }


      back.addEventListener(
        "click",
        function () {

          if (
            state.currentQuestion <= 0
          ) {

            return;

          }


          state.currentQuestion--;


          renderQuestion();


          trackEvent(
            "varikaa_ai_back",
            {

              product:
                product.id,

              question:
                state.currentQuestion + 1

            }
          );

        }
      );

    }


    /* ========================================================
       15. RESULT MAPPINGS
       ======================================================== */

    function getPrimaryResult() {

      var value =
        state.answers.q1;


      if (
        product.resultMapping &&
        product.resultMapping[value]
      ) {

        return product.resultMapping[
          value
        ];

      }


      return {

        intro:
          product.result.defaultIntro,

        focusTitle:
          "MetaFizz+",

        focusText:
          product.result.defaultIntro

      };

    }


    function getRoutineResult() {

      var value =
        state.answers.q2;


      if (
        product.routineMapping &&
        product.routineMapping[value]
      ) {

        return product.routineMapping[
          value
        ];

      }


      return null;

    }


    function getMotivationResult() {

      var value =
        state.answers.q3;


      if (
        product.motivationMapping &&
        product.motivationMapping[value]
      ) {

        return product.motivationMapping[
          value
        ];

      }


      return null;

    }


    function getPreferenceResult() {

      var value =
        state.answers.q4;


      if (
        product.preferenceMapping &&
        product.preferenceMapping[value]
      ) {

        return product.preferenceMapping[
          value
        ];

      }


      return null;

    }


    /* ========================================================
       16. RESULT ICON
       ======================================================== */

    function getResultIcon(
      type
    ) {

      var icons = {

        goal:
          "◎",

        routine:
          "◌",

        motivation:
          "✦",

        preference:
          "✓"

      };


      return icons[type] || "•";

    }


    /* ========================================================
       17. RESULT SCREEN
       ======================================================== */

    function showResult() {

      state.resultShown =
        true;


      ui.progressBar.style.width =
        "100%";


      var primary =
        getPrimaryResult();


      var routine =
        getRoutineResult();


      var motivation =
        getMotivationResult();


      var preference =
        getPreferenceResult();


      /*
      --------------------------------------------------------
      VISUAL SUMMARY
      --------------------------------------------------------
      */

      var visualCards = [];


      if (primary) {

        visualCards.push({

          type:
            "goal",

          label:
            "Your focus",

          title:
            primary.focusTitle

        });

      }


      if (routine) {

        visualCards.push({

          type:
            "routine",

          label:
            "Your routine",

          title:
            routine.title

        });

      }


      if (motivation) {

        visualCards.push({

          type:
            "motivation",

          label:
            "What matters",

          title:
            motivation.title

        });

      }


      if (preference) {

        visualCards.push({

          type:
            "preference",

          label:
            "Routine style",

          title:
            preference.title

        });

      }


      var visualCardsHtml =
        visualCards
          .slice(0, 3)
          .map(
            function (card) {

              return (

                '<div class="varikaa-ai-result-visual-card">' +

                  '<div class="varikaa-ai-result-visual-icon">' +

                    getResultIcon(
                      card.type
                    ) +

                  '</div>' +

                  '<div class="varikaa-ai-result-visual-copy">' +

                    '<div class="varikaa-ai-result-visual-label">' +

                      escapeHtml(
                        card.label
                      ) +

                    '</div>' +

                    '<div class="varikaa-ai-result-visual-title">' +

                      escapeHtml(
                        card.title
                      ) +

                    '</div>' +

                  '</div>' +

                '</div>'

              );

            }
          )
          .join("");


      /*
      --------------------------------------------------------
      REASONS
      --------------------------------------------------------
      */

      var reasons = [];


      if (primary) {

        reasons.push({

          title:
            primary.focusTitle,

          text:
            primary.focusText

        });

      }


      if (routine) {

        reasons.push({

          title:
            routine.title,

          text:
            routine.text

        });

      }


      if (motivation) {

        reasons.push({

          title:
            motivation.title,

          text:
            motivation.text

        });

      }


      if (preference) {

        reasons.push({

          title:
            preference.title,

          text:
            preference.text

        });

      }


      /*
      --------------------------------------------------------
      Keep recommendation concise.

      Maximum 3 expandable reasons.
      --------------------------------------------------------
      */

      var reasonsHtml =
        reasons
          .slice(0, 3)
          .map(
            function (reason) {

              return (

                '<div class="varikaa-ai-result-accordion">' +

                  '<button ' +
                    'type="button" ' +
                    'class="varikaa-ai-result-accordion-button"' +
                  '>' +

                    '<span>' +

                      escapeHtml(
                        reason.title
                      ) +

                    '</span>' +

                    '<strong>+</strong>' +

                  '</button>' +

                  '<div class="varikaa-ai-result-accordion-content">' +

                    escapeHtml(
                      reason.text
                    ) +

                  '</div>' +

                '</div>'

              );

            }
          )
          .join("");


      /*
      --------------------------------------------------------
      USAGE
      --------------------------------------------------------
      */

      var usageText =

        escapeHtml(
          product.usage.frequency
        ) +

        "<br><br>" +

        escapeHtml(
          product.usage.preparation
        ) +

        "<br><br>" +

        escapeHtml(
          product.usage.timing
        ) +

        "<br><br>" +

        escapeHtml(
          product.usage.hotWaterWarning
        );


      /*
      --------------------------------------------------------
      FAQ
      --------------------------------------------------------
      */

      var faqHtml =
        product.faqs
          .map(
            function (faq) {

              return (

                '<div class="varikaa-ai-faq-item">' +

                  '<button ' +
                    'type="button" ' +
                    'class="varikaa-ai-faq-button"' +
                  '>' +

                    '<span>' +

                      escapeHtml(
                        faq.question
                      ) +

                    '</span>' +

                    '<strong>+</strong>' +

                  '</button>' +

                  '<div class="varikaa-ai-faq-answer">' +

                    escapeHtml(
                      faq.answer
                    ) +

                  '</div>' +

                '</div>'

              );

            }
          )
          .join("");


      /*
      --------------------------------------------------------
      RESULT
      --------------------------------------------------------
      */

      ui.content.innerHTML =

        '<div class="varikaa-ai-result">' +

          '<div class="varikaa-ai-result-eyebrow">' +

            'Your personalised routine guide' +

          '</div>' +

          '<h2 class="varikaa-ai-result-title">' +

            escapeHtml(
              product.result.title
            ) +

          '</h2>' +

          '<p class="varikaa-ai-result-intro">' +

            escapeHtml(
              primary.intro
            ) +

          '</p>' +


          /*
          VISUAL SUMMARY
          */

          '<div class="varikaa-ai-result-visual">' +

            visualCardsHtml +

          '</div>' +


          /*
          WHY IT MAY FIT
          */

          '<div class="varikaa-ai-result-block">' +

            '<div class="varikaa-ai-result-section-label">' +

              'Why it may fit' +

            '</div>' +

            '<div class="varikaa-ai-result-accordions">' +

              reasonsHtml +

            '</div>' +

          '</div>' +


          /*
          HOW TO USE
          */

          '<div class="varikaa-ai-result-block">' +

            '<div class="varikaa-ai-result-section-label">' +

              'How to use' +

            '</div>' +

            '<div class="varikaa-ai-result-single-accordion">' +

              '<button ' +
                'type="button" ' +
                'class="varikaa-ai-result-accordion-button"' +
              '>' +

                '<span>' +

                  'Simple daily routine' +

                '</span>' +

                '<strong>+</strong>' +

              '</button>' +

              '<div class="varikaa-ai-result-accordion-content">' +

                usageText +

              '</div>' +

            '</div>' +

          '</div>' +


          /*
          FAQ
          */

          '<div class="varikaa-ai-result-block">' +

            '<div class="varikaa-ai-result-section-label">' +

              'Frequently asked questions' +

            '</div>' +

            '<div class="varikaa-ai-faqs">' +

              faqHtml +

            '</div>' +

          '</div>' +


          /*
          EXTRA SPACE UNDER STICKY CTA
          */

          '<div class="varikaa-ai-result-bottom-space"></div>' +


          /*
          STICKY CTA
          */

          '<div class="varikaa-ai-sticky-cta">' +

            '<button ' +
              'type="button" ' +
              'id="varikaa-ai-final-cta"' +
            '>' +

              escapeHtml(
                product.cta.buttonText
              ) +

            '</button>' +

            '<p class="varikaa-ai-cta-note">' +

              escapeHtml(
                product.cta.note
              ) +

            '</p>' +

          '</div>' +

        '</div>';


      bindResultAccordions();

      bindFAQs();

      bindFinalCTA();


      trackEvent(
        "varikaa_ai_result_viewed",
        {

          product:
            product.id,

          goal:
            state.answers.q1,

          routine:
            state.answers.q2,

          motivation:
            state.answers.q3,

          preference:
            state.answers.q4

        }
      );

    }


    /* ========================================================
       18. RESULT ACCORDIONS
       ======================================================== */

    function bindResultAccordions() {

      var buttons =
        ui.content.querySelectorAll(
          ".varikaa-ai-result-accordion-button"
        );


      buttons.forEach(
        function (button) {

          button.addEventListener(
            "click",
            function () {

              var item =
                button.parentElement;


              if (!item) {

                return;

              }


              var isOpen =
                item.classList.contains(
                  "is-open"
                );


              /*
              ------------------------------------------------
              Close other accordions in same group.
              ------------------------------------------------
              */

              var group =
                item.parentElement;


              if (group) {

                var siblings =
                  group.querySelectorAll(
                    ".varikaa-ai-result-accordion"
                  );


                siblings.forEach(
                  function (sibling) {

                    sibling.classList.remove(
                      "is-open"
                    );


                    var siblingButton =
                      sibling.querySelector(
                        ".varikaa-ai-result-accordion-button"
                      );


                    if (siblingButton) {

                      var siblingSymbol =
                        siblingButton.querySelector(
                          "strong"
                        );


                      if (siblingSymbol) {

                        siblingSymbol.textContent =
                          "+";

                      }

                    }

                  }
                );

              }


              if (!isOpen) {

                item.classList.add(
                  "is-open"
                );


                var symbol =
                  button.querySelector(
                    "strong"
                  );


                if (symbol) {

                  symbol.textContent =
                    "−";

                }

              }

            }
          );

        }
      );

    }


    /* ========================================================
       19. FAQ
       ======================================================== */

    function bindFAQs() {

      var buttons =
        ui.content.querySelectorAll(
          ".varikaa-ai-faq-button"
        );


      buttons.forEach(
        function (button) {

          button.addEventListener(
            "click",
            function () {

              var item =
                button.closest(
                  ".varikaa-ai-faq-item"
                );


              if (!item) {

                return;

              }


              var isOpen =
                item.classList.contains(
                  "is-open"
                );


              item.classList.toggle(
                "is-open"
              );


              var symbol =
                button.querySelector(
                  "strong"
                );


              if (symbol) {

                symbol.textContent =
                  isOpen
                    ? "+"
                    : "−";

              }

            }
          );

        }
      );

    }


    /* ========================================================
       20. FIND EXISTING PURCHASE BUTTON
       ========================================================

       IMPORTANT:

       We do NOT create checkout.

       We do NOT create Shiprocket checkout.

       We do NOT prevent existing events.

       We simply trigger the existing product-page
       purchase mechanism.

    ======================================================== */

    function isVisibleElement(
      element
    ) {

      if (!element) {

        return false;

      }


      if (
        element.disabled
      ) {

        return false;

      }


      var rect =
        element.getBoundingClientRect();


      return (
        rect.width > 0 &&
        rect.height > 0
      );

    }


    function getElementText(
      element
    ) {

      return (

        (
          element.innerText ||
          element.value ||
          element.getAttribute(
            "aria-label"
          ) ||
          ""
        )

          .trim()
          .toLowerCase()

      );

    }


    function findExistingPurchaseButton() {

      /*
      --------------------------------------------------------
      1. BUY NOW / BUY IT NOW BY VISIBLE TEXT
      --------------------------------------------------------
      */

      var buttons =
        document.querySelectorAll(
          "button, input[type='submit'], a"
        );


      for (
        var i = 0;
        i < buttons.length;
        i++
      ) {

        var button =
          buttons[i];


        if (
          !isVisibleElement(
            button
          )
        ) {

          continue;

        }


        var text =
          getElementText(
            button
          );


        if (
          text === "buy now" ||
          text === "buy it now" ||
          text.includes(
            "buy now"
          ) ||
          text.includes(
            "buy it now"
          )
        ) {

          return button;

        }

      }


      /*
      --------------------------------------------------------
      2. ACCELERATED CHECKOUT
      --------------------------------------------------------
      */

      var checkoutSelectors = [

        'button[name="checkout"]',

        'button[type="submit"][name="checkout"]',

        'input[name="checkout"]',

        'a[href*="/checkout"]'

      ];


      for (
        var j = 0;
        j < checkoutSelectors.length;
        j++
      ) {

        var checkoutButton =
          document.querySelector(
            checkoutSelectors[j]
          );


        if (
          isVisibleElement(
            checkoutButton
          )
        ) {

          return checkoutButton;

        }

      }


      /*
      --------------------------------------------------------
      3. NORMAL ADD TO CART FALLBACK
      --------------------------------------------------------
      */

      var addSelectors = [

        'form[action*="/cart/add"] button[type="submit"]',

        'form[action*="/cart/add"] input[type="submit"]',

        'button[name="add"]',

        'button[type="submit"][name="add"]'

      ];


      for (
        var k = 0;
        k < addSelectors.length;
        k++
      ) {

        var addButton =
          document.querySelector(
            addSelectors[k]
          );


        if (
          isVisibleElement(
            addButton
          )
        ) {

          return addButton;

        }

      }


      return null;

    }


    /* ========================================================
       21. CLOSE OUR MODAL
       ======================================================== */

    function closeGuideForCheckout() {

      ui.overlay.classList.remove(
        "is-open"
      );


      ui.overlay.setAttribute(
        "aria-hidden",
        "true"
      );


      document.documentElement.classList.remove(
        "varikaa-ai-lock-scroll"
      );


      document.body.classList.remove(
        "varikaa-ai-lock-scroll"
      );

    }


    /* ========================================================
       22. FINAL CTA
       ======================================================== */

    function bindFinalCTA() {

      var button =
        document.getElementById(
          "varikaa-ai-final-cta"
        );


      if (!button) {

        return;

      }


      button.addEventListener(
        "click",
        function () {

          trackEvent(
            "varikaa_ai_final_cta",
            {

              product:
                product.id,

              goal:
                state.answers.q1,

              routine:
                state.answers.q2,

              motivation:
                state.answers.q3,

              preference:
                state.answers.q4

            }
          );


          var existingPurchase =
            findExistingPurchaseButton();


          if (!existingPurchase) {

            button.textContent =
              "Please use the product button above";


            setTimeout(
              function () {

                button.textContent =
                  product.cta.buttonText;

              },
              2500
            );


            console.warn(
              "[Varikaa AI] Existing purchase button not found."
            );


            return;

          }


          /*
          ----------------------------------------------------
          Close OUR modal first.
          ----------------------------------------------------
          */

          closeGuideForCheckout();


          /*
          ----------------------------------------------------
          Give the browser a short render window,
          then trigger the EXISTING purchase mechanism.
          ----------------------------------------------------
          */

          setTimeout(
            function () {

              try {

                existingPurchase.click();

              } catch (error) {

                console.warn(
                  "[Varikaa AI] Purchase handoff failed.",
                  error
                );

              }

            },
            120
          );

        }
      );

    }


    /* ========================================================
       23. HERO EVENTS
       ======================================================== */

    ui.heroObject.addEventListener(
      "click",
      function () {

        openGuide();

      }
    );


    ui.invitation.addEventListener(
      "click",
      function () {

        openGuide();

      }
    );


    /* ========================================================
       24. CLOSE EVENTS
       ======================================================== */

    ui.close.addEventListener(
      "click",
      function () {

        closeGuide();

      }
    );


    ui.overlay.addEventListener(
      "click",
      function (event) {

        if (
          event.target ===
          ui.overlay
        ) {

          closeGuide();

        }

      }
    );


    document.addEventListener(
      "keydown",
      function (event) {

        if (
          event.key === "Escape" &&
          ui.overlay.classList.contains(
            "is-open"
          )
        ) {

          closeGuide();

        }

      }
    );


    /* ========================================================
       25. INITIAL CHECK
       ======================================================== */

    if (
      document.readyState ===
      "loading"
    ) {

      document.addEventListener(
        "DOMContentLoaded",
        checkScroll
      );

    } else {

      checkScroll();

    }


    console.log(
      "[Varikaa AI] MetaFizz+ V2 loaded."
    );

  }


  /* ==========================================================
     START ENGINE
     ========================================================== */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initVarikaaAI
    );

  } else {

    initVarikaaAI();

  }


})();